import { ApiProperty } from '../codegen';
import { IsOptional, IsString } from '../validators';

export class UTMDto {
  @ApiProperty()
  @IsOptional()
  @IsString()
  utm_source?: string;

  @ApiProperty()
  @IsOptional()
  @IsString()
  utm_medium?: string;

  @ApiProperty()
  @IsOptional()
  @IsString()
  utm_campaign?: string;

  @ApiProperty()
  @IsOptional()
  @IsString()
  utm_content?: string;

  @ApiProperty()
  @IsOptional()
  @IsString()
  utm_term?: string;
}
